export const supportsIntlRelativeTimeFormat = () => {
  return !!window?.Intl?.RelativeTimeFormat;
};

export const installRelativeTimeFormatPolyfills = (): Promise<unknown> => {
  if (supportsIntlRelativeTimeFormat()) return Promise.resolve();

  return import(
    /* webpackChunkName: "intl-relativetimeformat" */ '@formatjs/intl-relativetimeformat/polyfill'
  );
};

export const setIframeSrcDoc = (
  iframe: HTMLIFrameElement,
  content: string,
): void => {
  iframe.srcdoc = content;
};
